import ModalController from './ModalController';
/**
 * Registers a modal directive with the given module.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerModalDirective(angular) {
    const module = angular.module('assessmentFrontendDirectives');

    module.directive('modal', ['$compile', function($compile) {
        return {
            restrict: 'E', // Restricts the directive to be used as an element only.
            replace: true, // Replaces the HTML element with the template.
            templateUrl: '/views/ib/components/ModalDirective.html', // URL of the template to be used for the directive.
            controller: ModalController // Controller associated with the directive.
        };
    }]);
}